import React from 'react'
import { Link, Outlet, useNavigate } from 'react-router-dom'

import { Navbar } from '../../../components/layouts/navbar'
import Logo from '../../../assets/logoKeap.png'
import { AlertFunctional } from '../../../components/ui/alert/AlertFunctional'
import { useGlobalContext } from '../../../context/ContextGlobal'
import { logOut } from '../../../firebase/auth'
import { RemoveItemSession } from '../../../utils/sessionStorage'
import { Path } from '../../../router/paths'
import { Icon } from '../../../components/icons'
import { TransformationforMask } from '../../../utils/masks'

export const ClientLayoutNavBar = () => {
  const { alerts, setAlerts, navBar, setNavBar, setUser, user } = useGlobalContext()

  const navigate = useNavigate()

  const sair = () => {
    // console.log(Path.Login)
    logOut()
    RemoveItemSession({ key: 'user' })
    setUser([])
    return navigate(Path.Login)
  }

  return (
    <>
      <Navbar.Root
        color={user?.colornavbar || user?.client?.colornavbar || '#210057'}
        active={navBar}
        setActive={setNavBar}
        logo={user?.client?.logoUrl || Logo}
      >
        <Navbar.End>
          <Navbar.ItemInfo colorText={'has-text-grey mr-5'}>
            <p className="control ml-4">
              <Link to={Path.AdministrationHome} title="voltar à página inicial">
                <figure className="image is-48x48 mr-3 mt-1">
                  <img className="is-rounded" src={user?.user?.url_foto} alt="" />
                </figure>
              </Link>
            </p>
            <p className="control is-flex is-justify-content-center">
              <label className="mt-4" style={{ color: 'white' }}>
                {TransformationforMask(`${user?.user?.nome}`, 'title')}
              </label>
            </p>
          </Navbar.ItemInfo>

          <Navbar.Dropdown title="Eventos">
            <Navbar.Link colorText={'text-drop-down'} link={'/cliente'}>
              <Icon size={15} className="mr-2">
                comparison
              </Icon>
              Dashboard
            </Navbar.Link>
            <Navbar.Link colorText={'text-drop-down'} link={Path.ClientEvents}>
              <Icon size={15} className="mr-2">
                calendar
              </Icon>
              Meus Eventos
            </Navbar.Link>
            <Navbar.Link colorText={'text-drop-down'} link={Path.ClientFavorites}>
              <Icon size={15} className="mr-2">
                favorite
              </Icon>
              Staffers Favoritos
            </Navbar.Link>
            <Navbar.Link colorText={'text-drop-down'} link={Path.ClientBlockeds}>
              <Icon size={15} className="mr-2">
                block
              </Icon>
              Staffers Bloqueados
            </Navbar.Link>
            <Navbar.Link colorText={'text-drop-down'} link={Path.ClientCampaigns}>
              <Icon size={15} className="mr-2">
                user_arrows
              </Icon>
              Promover Campanha
            </Navbar.Link>
          </Navbar.Dropdown>

          <Navbar.Link link={Path.ClientSettings}>Configurações</Navbar.Link>
          <Navbar.Action action={sair}>Sair</Navbar.Action>
        </Navbar.End>
      </Navbar.Root>

      {/* Faz com que o conteudo mude mudando de pagina */}
      <Outlet />
      <AlertFunctional values={alerts} setValues={setAlerts}></AlertFunctional>
    </>
  )
}
